import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var User02 = function User02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 15c-3.1701 0-5.9892 1.5306-7.784 3.906-.3863.5112-.5795.7668-.5732 1.1123.005.2669.1725.6036.3825.7684C4.2972 21 4.6738 21 5.4272 21h13.1455c.7534 0 1.1301 0 1.4019-.2133.21-.1648.3776-.5015.3825-.7684.0063-.3455-.1868-.6011-.5731-1.1123C17.9892 16.5306 15.17 15 12 15m0-3c2.4853 0 4.5-2.0147 4.5-4.5S14.4853 3 12 3 7.5 5.0147 7.5 7.5 9.5147 12 12 12"
    })
  }));
};
export default User02;